import React, { useState, useRef, useEffect } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import axios from "axios";
import { main_link } from "../Connection/Connection";

import { Toast } from "primereact/toast";

import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { Form } from "react-bootstrap";

import { MultiSelect } from "react-multi-select-component";
//
const EditSchedule = (props) => {
  const editSchd = props.editSchd;
  const show = props.show;
  const setShow = props.setShow;

  const setCounter = props.setCounter;
  const counter = props.counter;

  const toast = useRef(null);
  const [loading, setLoading] = useState(false);
  const [day, setDay] = useState(editSchd.day);
  const [time, setTime] = useState(editSchd.time);
  const [id, setID] = useState(editSchd.sch_id);

  useEffect(() => {
    setDay("");
    setTime("");
    setID("");
  }, [editSchd]);

  useEffect(() => {
    setDay(editSchd.day);
    setTime(editSchd.time);
    setID(editSchd.sch_id);
  }, [editSchd]);

  const [hours, setHours] = useState([]);

  const day_hours = [
    { label: "12:00 AM", value: "12:00 AM" },
    { label: "12:30 AM", value: "12:30 AM" },
    { label: "1:00 AM", value: "1:00 AM" },
    { label: "1:30 AM", value: "1:30 AM" },
    { label: "2:00 AM", value: "2:00 AM" },
    { label: "2:30 AM", value: "2:30 AM" },
    { label: "3:00 AM", value: "3:00 AM" },
    { label: "3:30 AM", value: "3:30 AM" },
    { label: "4:00 AM", value: "4:00 AM" },
    { label: "4:30 AM", value: "4:30 AM" },
    { label: "5:00 AM", value: "5:00 AM" },
    { label: "5:30 AM", value: "5:30 AM" },
    { label: "6:00 AM", value: "6:00 AM" },
    { label: "6:30 AM", value: "6:30 AM" },
    { label: "7:00 AM", value: "7:00 AM" },
    { label: "7:30 AM", value: "7:30 AM" },
    { label: "8:00 AM", value: "8:00 AM" },
    { label: "8:30 AM", value: "8:30 AM" },
    { label: "9:00 AM", value: "9:00 AM" },
    { label: "9:30 AM", value: "9:30 AM" },
    { label: "10:00 AM", value: "10:00 AM" },
    { label: "10:30 AM", value: "10:30 AM" },
    { label: "11:00 AM", value: "11:00 AM" },
    { label: "11:30 AM", value: "11:30 AM" },
    { label: "12:00 PM", value: "12:00 PM" },
    { label: "12:30 PM", value: "12:30 PM" },
    { label: "1:00 PM", value: "1:00 PM" },
    { label: "1:30 PM", value: "1:30 PM" },
    { label: "2:00 PM", value: "2:00 PM" },
    { label: "2:30 PM", value: "2:30 PM" },
    { label: "3:00 PM", value: "3:00 PM" },
    { label: "3:30 PM", value: "3:30 PM" },
    { label: "4:00 PM", value: "4:00 PM" },
    { label: "4:30 PM", value: "4:30 PM" },
    { label: "5:00 PM", value: "5:00 PM" },
    { label: "5:30 PM", value: "5:30 PM" },
    { label: "6:00 PM", value: "6:00 PM" },
    { label: "6:30 PM", value: "6:30 PM" },
    { label: "7:00 PM", value: "7:00 PM" },
    { label: "7:30 PM", value: "7:30 PM" },
    { label: "8:00 PM", value: "8:00 PM" },
    { label: "8:30 PM", value: "8:30 PM" },
    { label: "9:00 PM", value: "9:00 PM" },
    { label: "9:30 PM", value: "9:30 PM" },
    { label: "10:00 PM", value: "10:00 PM" },
    { label: "10:30 PM", value: "10:30 PM" },
    { label: "11:00 PM", value: "11:00 PM" },
    { label: "11:30 PM", value: "11:30 PM" },
  ];

  const update = async () => {
    const user = JSON.parse(sessionStorage.getItem("user-data"));
    const user_id = user["encrypted_id"];

    setLoading(true);

    const hoursArray = [];

    hours.forEach((element) => {
      const temp_hrs_value = element["value"];
      hoursArray.push(temp_hrs_value);
    });

    sortTimes(hoursArray);

    const hoursJsonString = JSON.stringify(hoursArray);

    try {
      const response = await axios.post(main_link + "updateSchedule", {
        id,
        hoursJsonString,
        user_id,
      });

      setLoading(false);
      // console.log(response.data);

      if (response.data.message == "Updated Successfully.") {
        setShow(false);
        setCounter(counter + 1);

        toast.current.show({
          severity: "success",
          summary: "success",
          detail: "Updated Successfully.",
        });
      } else {
      }
    } catch (error) {
      setLoading(false);
      console.log(error.response.data);
      // let errorMessage = "";
      // Object.values(error.response.data.errors).forEach((errorArray) => {
      //   errorArray.forEach((error) => {
      //     errorMessage += error + "\n";
      //   });
      // });
      // // setMsg(errorMessage);
      // toast.current.show({
      //   severity: "error",
      //   summary: "error",
      //   detail: errorMessage,
      // });
    }
    setLoading(false);
  };

  function sortTimes(timesArray) {
    return timesArray.sort((a, b) => {
      const dateA = new Date(`1970/01/01 ${a}`);
      const dateB = new Date(`1970/01/01 ${b}`);
      return dateA - dateB;
    });
  }

  return (
    <>
      <Toast ref={toast} />
      <Modal
        show={show}
        onHide={() => setShow(false)}
        backdrop="static"
        keyboard={false}
        size="lg"
      >
        <Modal.Header closeButton className="bg-primary">
          <Modal.Title>Edit {day}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Container>
              <Row>
                <Col>
                  <Form.Group className="mb-3" controlId="formBasicEmail">
                    <Form.Label>Day</Form.Label>
                    <Form.Control readOnly disabled value={day} />
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Form.Group className="mb-3" controlId="formBasicEmail">
                    <Form.Label>Time</Form.Label>
                    <textarea
                      className="form-control"
                      rows={10}
                      placeholder="Any Description ..."
                      defaultValue={time}
                      readOnly
                      disabled
                    />
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col>
                  <div className="form-group">
                    <label htmlFor="days">Sechdule Days</label>
                    <MultiSelect
                      options={day_hours}
                      value={hours}
                      onChange={setHours}
                      labelledBy="Select"
                      className="text-primary"
                      style={{
                        backgroundColor: "red",
                        color: "red",
                        fontSize: "30px",
                      }}
                    />
                  </div>
                </Col>
              </Row>
            </Container>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShow(false)}>
            Close
          </Button>
          {!loading && (
            <Button variant="primary" onClick={update}>
              Update
            </Button>
          )}
          {loading && (
            <Button variant="primary" disabled>
              Updating...
            </Button>
          )}
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default EditSchedule;
